import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { WalletProvider, WalletContext } from './context/WalletContex';
import AppShell from './components/layout/AppShell';

import Welcome         from './screens/Welcome';
import EmailVerified   from './screens/EmailVerified';
import Legal           from './screens/Legal';
import MnemonicDisplay from './screens/MnemonicDisplay';
import Dashboard from './screens/Dashboard';
import Send     from './screens/Send';
import Receive  from './screens/Receive';
import History  from './screens/History';
import Swap     from './screens/Swap';
import P2P      from './screens/P2P';
import Profile  from './screens/Profile';

function GuardedRoutes() {
  const { wallet } = React.useContext(WalletContext);

  if (!wallet) return <Navigate to="/welcome" replace />;

  return (
    <AppShell>
      <Routes>
        <Route path="/home"    element={<Dashboard />} />
        <Route path="/send"    element={<Send />} />
        <Route path="/receive" element={<Receive />} />
        <Route path="/history" element={<History />} />
        <Route path="/swap"    element={<Swap />} />
        <Route path="/p2p"     element={<P2P />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="*"        element={<Navigate to="/home" replace />} />
      </Routes>
    </AppShell>
  );
}

export default function App() {
  return (
    <WalletProvider>
      <BrowserRouter>
        <ToastContainer
          position="top-center"
          autoClose={3000}
          newestOnTop
          closeOnClick
          pauseOnFocusLoss={false}
          draggable
          toastStyle={{
            background: '#1A1748',
            color: '#fff',
            border: '1px solid rgba(255,255,255,0.1)',
            borderRadius: '14px',
          }}
        />
        <Routes>
          <Route path="/welcome"  element={<WelcomeGuard />} />
          <Route path="/verified" element={<EmailVerified />} />
          <Route path="/legal"    element={<Legal />} />
          <Route path="/*"        element={<GuardedRoutes />} />
        </Routes>
      </BrowserRouter>
    </WalletProvider>
  );
}

function WelcomeGuard() {
  const { wallet, step } = React.useContext(WalletContext);
  if (wallet && step === 'mnemonic') return <MnemonicDisplay />;
  if (wallet) return <Navigate to="/home" replace />;
  return <Welcome />;
}
